import React, { memo } from 'react';
import { CarouselProps } from 'react-responsive-carousel';
import { StyledCarousel, StyledCarouselWrapper } from './styles/Carousel';

/**
 * @deprecated Please use `import { Carousel } from '@minecraft.molecules'` instead.
 * This component will be removed in a future release.
 */
type Props = {
  className?: string;
  carouselProps?: CarouselProps;
  children: JSX.Element[];
  currentSlide?: number;
  updateCurrentSlide?: (index: number) => void;
} & CarouselProps;

/**
 * @deprecated Please use `import { Carousel } from '@minecraft.molecules'` instead.
 * This component will be removed in a future release.
 */
const Carousel = ({ className, carouselProps, children, currentSlide, updateCurrentSlide }: Props): JSX.Element => {
  return (
    <StyledCarouselWrapper className={className}>
      <StyledCarousel
        className={className}
        showThumbs={false}
        showStatus={false}
        selectedItem={currentSlide !== undefined ? currentSlide : null}
        onChange={updateCurrentSlide || null}
        emulateTouch
        swipeable
        {...carouselProps}
      >
        {children}
      </StyledCarousel>
    </StyledCarouselWrapper>
  );
};

export default memo(Carousel);
